import axios from 'axios'
import { isProduction } from './index'
import { Toast } from 'vant'
// 接口返回数据格式不定
// eslint-disable-next-line
const getFirstError = (err: any): any => {
  if (!err) return ''
  if (typeof err === 'string') return err
  if (Array.isArray(err)) return getFirstError(err[0])
  return getFirstError(err[Object.keys(err)[0]])
}

const http = axios.create({
  baseURL: isProduction ? process.env.VUE_APP_API : '/api',
  timeout: 10000,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
    'X-Requested-With': 'XMLHttpRequest'
  }
})

http.interceptors.request.use(
  config => {
    config.headers.token = sessionStorage.getItem('token')
    config.headers['auth-key'] = sessionStorage.getItem('auth-key')
    return config
  }
)

http.interceptors.response.use(
  ({ data: res }) => {
    if (res.status === 1) return res.data
    return Promise.reject(new Error(getFirstError(res.data) || res.msg))
  },
  error => {
    if (error && error.response) {
      switch (error.response.status) {
        case 400: error.message = '请求错误'; break
        case 401: error.message = '未授权，请登录'; break
        case 403: error.message = '拒绝访问'; break
        case 404: error.message = `请求地址出错: ${error.response.config.url}`; break
        case 408: error.message = '请求超时'; break
        case 500: error.message = '服务器内部错误'; break
        case 501: error.message = '服务未实现'; break
        case 502: error.message = '网关错误'; break
        case 503: error.message = '服务不可用'; break
        case 504: error.message = '网关超时'; break
        case 505: error.message = 'HTTP版本不受支持'; break
        default: break
      }
    }
    console.log(JSON.stringify(error))
    Toast.fail(error.message)
    return Promise.reject(error)
  }
)

export default http
